import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M7 16c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3M2 3a1.001 1.001 0 0 1 2 0 1.001 1.001 0 0 1-2 0m15-1a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2m0 12c-.807 0-1.537.324-2.077.844l-2.96-1.481c.009-.122.037-.238.037-.363a4.964 4.964 0 0 0-.833-2.753l4.54-4.54.006-.009A2.96 2.96 0 0 0 17 6c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .463.114.896.302 1.287-.003.003-.007.003-.009.006l-4.54 4.54A4.966 4.966 0 0 0 7 8c-.125 0-.241.027-.363.037L5.156 5.076C5.676 4.537 6 3.807 6 3c0-1.654-1.346-3-3-3S0 1.346 0 3s1.346 3 3 3c.125 0 .243-.021.363-.037l1.318 2.635C3.095 9.437 2 11.085 2 13c0 2.757 2.243 5 5 5 1.916 0 3.563-1.095 4.402-2.681l2.635 1.318c-.015.12-.037.238-.037.363 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3"
});

var SvgAffiliateMajorMonotone = function SvgAffiliateMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgAffiliateMajorMonotone as S };